import React from 'react';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import { Translate } from 'react-redux-i18n';
import Button from '../../../../common/Button';
import { PairingCodeDTO } from '../../../../../network/api/types/compte/PairingCodeDTO';
import compteApi from '../../../../../network/api/compteApi';
import { HOME_PAGE_ROUTE } from '../../../../../routes';

type Props = RouteComponentProps & {
  onClose: () => void
};

type State = {
  pairingCodes: PairingCodeDTO
};

class PairDeviceStepTwo extends React.Component<Props, State> {
  state: State = {
    pairingCodes: null,
  };

  componentDidMount(): void {
    compteApi.fetchMyQRCodes()
      .catch(() => {})
      .then((prCodes) => {
        const pairingCodes = prCodes || {
          code: null,
          qrcode: null,
        };
        this.setState({ pairingCodes });
      });
  }

  render() {
    return (
      <>
        <div className="qr-step-container">
          <div className="subtitle">
            <Translate value="PAIR_DEVICE.STEP_TWO" />
          </div>
          {this.state.pairingCodes && !this.state.pairingCodes.qrcode ? (
            <Translate value="PAIR_DEVICE.CODE_ERROR" />
          ) : (
            <>
              <div className="qr-instructions">
                <Translate value="PAIR_DEVICE.INSTRUCTION_QRCODE" />
              </div>
              <div className="qr-code">
                {
            this.state.pairingCodes && (
            <>
              <img className="qr-image" src={`data:image/png;base64,${this.state.pairingCodes.qrcode}`} alt="qrcodezedz" />
              <span className="qr-code-text">{this.state.pairingCodes.code}</span>
            </>
            )
          }
              </div>
              <div className="qr-instructions">
                <Translate value="PAIR_DEVICE.FOLLOW_INSTRUCTIONS" />
              </div>
            </>
          )}

        </div>
        <div className="button-container">
          <Button
            type="third"
            onClick={this.props.onClose}
            i18nKey="actions.CANCEL"
          />
          <Button
            type="primary"
            onClick={() => {
              this.props.history.push(HOME_PAGE_ROUTE);
              // ici on peut juste refaire l'appel pour les appareils au lieu d'un reload ?
              window.location.reload();
            }}
            i18nKey="actions.END"
          />
        </div>
      </>
    );
  }
}

export default withRouter(PairDeviceStepTwo);
